<template>
  <v-navigation-drawer
      v-model="showLeftMenu"
      left
      fixed
      touchless
      clipped
      class="navigation-menu"
    >
      <v-list class="pa-1">

        <v-list-tile class="pt-1" tag="div" @click="goHomeAndClearSearch">
          <v-list-tile-action>
            <v-btn icon @click.stop="showLeftMenu = false" color="white">
              <v-icon>close</v-icon>
            </v-btn>
          </v-list-tile-action>

        </v-list-tile>

      </v-list>

      <v-list class="pt-2 mobile-contact-options">
        <v-list-tile
          v-for="(item, index) in contactOptions()"
          :key="index"
          class="mobile-contact-options"
        >
          <v-list-tile-action>
            <a :href="item.link" class="normal-link mobile-contact-icon" target="_blank">
              <v-icon>{{ item.icon }}</v-icon>
            </a>
          </v-list-tile-action>
          <v-list-tile-title>
            <a :href="item.link" class="normal-link mobile-contact-text" target="_blank">
              {{ $i18n.t(item.title_translation) + (item.colon ? ':' : '') }}
              {{ item.title }}
            </a>
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile class="mobile-contact-options">
          <v-list-tile-action>
          </v-list-tile-action>
          <v-list-tile-title>
            <b>{{ $i18n.t('mobile-contacts-menu-message') !== 'mobile-contacts-menu-message' ? $i18n.t('mobile-contacts-menu-message') : '' }}</b>
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
</template>

<script>
import sharedMethods from './../methods/sharedMethods'
import { createHelpers } from 'vuex-map-fields'
import state from './../state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'RightMenu',

  data () {
    return {
      showMenuId: null
    }
  },

  computed: {
    ...mapFields(Object.keys(state))
  },

  methods: {
    ...sharedMethods
  }
}
</script>

<style>
.mobile-contact-options {
  color: white !important;
  margin-top: 5px;
  padding-left: 10px;
}
.mobile-contact-options {
  margin-bottom: 15px;
}
.mobile-contact-icon i {
  color: white !important;
}
.mobile-contact-text {
  white-space: inherit !important;
  overflow: inherit !important;
}
</style>
